<template>
  <OmtStickedModal v-if="isOpen" @close="$emit('close')">
    <template #header>
      <CFlex align-items="center" justify-content="space-between"
w="100%">
        <CBox flex="1" text-align="center">
          <OmtTypography as="h2-bold" lineHeight="32px">Buscar outro endereço</OmtTypography>
        </CBox>
      </CFlex>
    </template>

    <CBox display="flex" flex-direction="column" gridGap="16px" mb="24px">
      <CFlex direction="column" mb="12px">
        <OmtTypography as="p1" mb="4px">Estado</OmtTypography>
        <OmtSelect
          v-model="selectedState"
          variant="outline"
          borderRadius="8px"
          placeholder="Selecione o estado"
          @change="onStateChange"
        >
          <option v-for="state in states" :key="state.Codigo"
:value="state.Codigo">
            {{ state.Descricao }}
          </option>
        </OmtSelect>
      </CFlex>
      <CFlex direction="column" mb="12px">
        <OmtTypography as="p1" mb="4px">Cidade</OmtTypography>
        <OmtSelect
          v-model="selectedCity"
          variant="outline"
          borderRadius="8px"
          placeholder="Selecione a cidade"
          :disabled="!cities.length"
          @change="onCityChange"
        >
          <option v-for="city in cities" :key="city.Codigo"
:value="city.Codigo">
            {{ capitalize(city.Descricao) }}
          </option>
        </OmtSelect>
      </CFlex>
      <CBox
        border="0.5px solid var(--colors-light-primary-navy-blue)"
        border-radius="8px"
        p="16px"
        bg="#EBF0FE"
        mb="24px"
      >
        <OmtTypography as="p1" color="var(--colors-light-primary-gray1)">
          Apenas estados e cidades com prestadores ativos são exibidos.
        </OmtTypography>
      </CBox>

      <CBox mt="auto" w="100%">
        <OmtButton w="100%" height="40px" borderRadius="40px" :isDisabled="!isFormValid"
@click="applySelection">
          <OmtTypography as="h3-bold" color="white">Aplicar</OmtTypography>
        </OmtButton>
      </CBox>
    </CBox>
  </OmtStickedModal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { capitalize } from "@/utils/utils";

export default {
  name: "ModalSearchOtherAddress",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      cities: [],
      selectedState: "",
      selectedCity: ""
    };
  },
  computed: {
    ...mapState("affiliate", ["states"]),
    isFormValid() {
      return !!this.selectedState && !!this.selectedCity;
    }
  },
  methods: {
    ...mapActions("affiliate", ["fetchCitiesNetwork"]),
    async onStateChange(event) {
      // Quando é um select nativo ou o componente propaga o valor diretamente
      this.selectedState = event?.target ? event.target.value : event;
      this.selectedCity = "";
      this.cities = [];

      if (!this.selectedState) return;

      try {
        await this.$root.$emit("show-loading");
        const citiesResponse = await this.fetchCitiesNetwork({ estado: this.selectedState });
        this.cities = citiesResponse || [];
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      } finally {
        await this.$root.$emit("hide-loading");
      }
    },
    onCityChange(event) {
      this.selectedCity = event?.target ? event.target.value : event;
    },
    capitalize(text) {
      return capitalize(text);
    },
    applySelection() {
      if (!this.isFormValid) return;

      const stateData = this.states.find(s => s.Codigo === this.selectedState);
      const cityData = this.cities.find(c => c.Codigo === this.selectedCity);

      this.$emit("apply", {
        type: "outra-cidade-selecionada",
        data: {
          CodigoEstado: this.selectedState,
          NomeEstado: stateData?.Descricao || "",
          CodigoCidade: this.selectedCity,
          NomeCidade: cityData?.Descricao || "",
          Titulo: "Busca em outra cidade",
          Descricao: `${cityData?.Descricao || ""} - ${stateData?.Descricao || ""}`
        }
      });

      this.$emit("close");
    }
  },
  watch: {
    isOpen(value) {
      if (!value) {
        this.selectedState = "";
        this.selectedCity = "";
        this.cities = [];
      }
    }
  }
};
</script>
